var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tenantHasFeature('SureLC', _vm.agent.TenantID))?_c('q-agent-licensing-sure-lc',{attrs:{"agent":_vm.agent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }